import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell,
    Select,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import CityService from "./Locality/Service/cityService";
import * as Yup from 'yup';
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import Widget from "../../components/Widget/Widget";

import PageTitle from "../../components/PageTitle/PageTitle";

import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

export default function City() {
    const tableHeaders = ['City', 'Status', 'Actions'];
    const classes = useStyles();
    const [cityList, setCityList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [cityToDelete, setCityToDelete] = React.useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [city, setCity] = useState({
        city: '',
        status: true,
    });

    const validationSchema = Yup.object().shape({
        city: Yup.string().required('City is required'),
        status: Yup.boolean().required('Status is required'),
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    useEffect(() => {
        getCityList();
        return () => {
            setCityList([]);
        };
    }, []);

    const getCityList = () => {
        CityService.getAllCity().then((res) => {
            setCityList(res);
        }).catch((err) => {
            console.error(err);
            alert("Error fetching cities: " + (err.response?.data?.message || err.message));
        });
    };

    const handleOpen = () => {
        setCity({
            city: '',
            status: true,
        });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCity({
            city: '',
            status: true,
        });
    };

    const editCity = (cityItem) => {
        const obj = {
            _id: cityItem._id,
            city: cityItem.city || '',
            status: cityItem.status !== undefined ? cityItem.status : true,
        };
        setCity(obj);
        setOpen(true);
    };

    const handleDeleteClick = (cityItem) => {
        setCityToDelete(cityItem);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (cityToDelete) {
            CityService.deleteCity(cityToDelete).then((res) => {
                getCityList();
                setDeleteDialogOpen(false);
                setCityToDelete(null);
                alert("City Deleted Successfully.");
            }).catch((err) => {
                alert("Error deleting city: " + (err.response?.data?.message || err.message));
            });
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setCityToDelete(null);
    };

    const formik = useFormik({
        initialValues: city,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            if (city._id) {
                values._id = city._id;
                CityService.updateCity(values).then((res) => {
                    handleClose();
                    getCityList();
                    resetForm();
                    setCity({
                        city: '',
                        status: true,
                    });
                    alert("City Updated Successfully.");
                }).catch((err) => {
                    alert("Error updating city: " + (err.response?.data?.message || err.message));
                });
            } else {
                CityService.createCity(values).then((res) => {
                    getCityList();
                    resetForm();
                    handleClose();
                    setCity({
                        city: '',
                        status: true,
                    });
                    alert("City Added Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error adding city");
                });
            }
        },
    });

    return (
        <>
            <PageTitle title="City Master" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(112, 57, 177)' }}> Add City
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Table className="mb-0">
                            <TableHead>
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {cityList.slice(pg * rpg, pg * rpg + rpg).map((cityItem) => (
                                    <TableRow key={cityItem._id}>
                                        <TableCell className="pl-3 fw-normal">{cityItem.city}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            <Typography
                                                size="sm"
                                                color={cityItem.status ? "success" : "secondary"}
                                            >
                                                {cityItem.status ? "Active" : "Inactive"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    aria-label="edit"
                                                    onClick={() => editCity(cityItem)}
                                                    color="primary"
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete">
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={() => handleDeleteClick(cityItem)}
                                                    color="secondary"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={cityList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>

            {/* Add/Edit Dialog */}
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {city._id ? "Edit City" : "Add City"}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3} style={{ marginTop: 8 }}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="city"
                                    name="city"
                                    label="City"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.city}
                                    error={formik.touched.city && Boolean(formik.errors.city)}
                                    helperText={formik.touched.city && formik.errors.city}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="status-label">Status</InputLabel>
                                    <Select
                                        labelId="status-label"
                                        id="status"
                                        name="status"
                                        value={formik.values.status}
                                        onChange={formik.handleChange}
                                        label="Status"
                                        error={formik.touched.status && Boolean(formik.errors.status)}
                                    >
                                        <MenuItem value={true}>Active</MenuItem>
                                        <MenuItem value={false}>Inactive</MenuItem>
                                    </Select>
                                    {formik.touched.status && formik.errors.status && (
                                        <Typography size="sm" color="error" style={{ marginTop: 8, marginLeft: 14 }}>
                                            {formik.errors.status}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button
                        onClick={formik.handleSubmit}
                        color="primary"
                        variant="contained"
                        style={{ backgroundColor: 'rgb(112, 57, 177)' }}
                    >
                        {city._id ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete the city "{cityToDelete?.city}"? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="secondary" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

